import { ButtonDesktop } from '@tui-react/button';
import { TuiIconTdsMediumPragmaticLoupePlus } from '@tui-react/proprietary-icons';
import React from 'react';
import styles from './ZoomImageButton.module.css';

export interface ZoomImageButtonProps {
  className?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const ZoomImageButton: React.FC<ZoomImageButtonProps> = ({ className, onClick }) => {
  return (
    <div className={className}>
      <ButtonDesktop
        iconLeft={
          <TuiIconTdsMediumPragmaticLoupePlus iconSize="var(--icon-s)" theme={{ color: 'var(--tui-text-primary)' }} />
        }
        onClick={onClick}
        appearance={'floating'}
        size={'m'}
        UNSAFE_className={styles.zoomImageButton}
        aria-label="Увеличить изображение"
      />
    </div>
  );
};
